export interface IMakeRequestConfig {
  method: string;
  url: string;
  headers: [string, string][];
  withCredentials?: boolean;
  body?: string;
}

export interface IMakeJSONPRequestConfig {
  url: string;
}

export interface ITask {
  // tslint:disable-next-line:no-any
  (): Promise<any>;
}

export interface IValidationInfo {
  logOnInfo: ILogOnInfo[];
  login: string;
  redirectBeforeAuthenticate: boolean;
  redirectUrl?: string;
  message?: string;
  errors?: ILoginError[];
}

export interface ILoginError {
  key: string;
  message: string;
  code: number | string | null;
}

export interface ILogOnInfo {
  logOnUrl: string;
  token: string;
}

// tslint:disable-next-line:no-any
function seriesP(tasks: ITask[]): Promise<any> {
  return tasks.reduce((acc, task) => acc.then(task), Promise.resolve());
}

let jsonpCounter = 0;
function makeJSONPRequest<T>(config: IMakeJSONPRequestConfig) {
  return new Promise((resolve, reject) => {
    const hash = `_jsonpCallback${jsonpCounter++}`;

    const script = document.createElement('script');
    script.async = true;
    script.src = config.url.indexOf('?') >= 0
      ? `${config.url}&_=${Math.random()}&callback=${hash}`
      : `${config.url}?_=${Math.random()}&callback=${hash}`;
    script.onerror = (e) => {
      reject(e);
    };

    // tslint:disable-next-line:no-any
    (window as any)[hash] = (data: T) => {
      document.head.removeChild(script);
      // tslint:disable-next-line:no-any
      delete (window as any)[hash];
      resolve(data);
    };

    document.head.appendChild(script);
  });
}

function makeRequest(config: IMakeRequestConfig) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    const url = config.url.indexOf('?') >= 0
      ? `${config.url}&_=${Math.random()}`
      : `${config.url}?_=${Math.random()}`;

    xhr.open(config.method, url, true);

    if (typeof config.withCredentials !== 'undefined') {
      xhr.withCredentials = config.withCredentials;
    } else {
      xhr.withCredentials = true;
    }

    config.headers.forEach(header => {
      xhr.setRequestHeader(header[0], header[1]);
    });

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        try {
          resolve(xhr.responseText);
        } catch (e) {
          reject(e);
        }
      }
    };

    xhr.onerror = (e) => {
      reject(e);
    };

    if (config.body) {
      xhr.send(config.body);
    } else {
      xhr.send();
    }
  });
}

export function logOut(host: string = '') {
  return makeRequest({
    method: 'GET',
    url: `${host}/api/users/logout-urls/`,
    headers: [],
    withCredentials: false,
  }).then((body: string) => {
    return processLinks(JSON.parse(body));
  });
}

export function logOn(login: string, password: string, persistent: boolean, host: string = '') {
  return makeRequest({
    method: 'POST',
    url: `${host}/v1/validate-login-password`,
    headers: [[ 'Content-Type', 'application/x-www-form-urlencoded' ]],
    body: `login=${encodeURIComponent(login)}&` +
            `password=${encodeURIComponent(password)}`,
  })
  .then((body: string) => {
    const res: IValidationInfo = JSON.parse(body);

    if (res.errors) {
      return Promise.reject(res);
    }

    return authenticate(res.logOnInfo, res.login, persistent);
  });
}

function processLinks(logoutLinks: string[]) {
  return seriesP(logoutLinks.map(logoutLink => {
    return () => performLogout(logoutLink);
  }));
}

function performLogout(logoutUrl: string) {
  return makeJSONPRequest({
    url: logoutUrl,
  });
}

export function authenticate(logOnInfoItems: ILogOnInfo[], login: string, persistent: boolean) {
  return seriesP(logOnInfoItems.map(logOnInfoItem => {
    return () => authenticateSite(logOnInfoItem, login, persistent);
  }));
}

function authenticateSite(logOnInfo: ILogOnInfo, login: string, persistent: boolean) {
  return makeJSONPRequest({
    url: `${logOnInfo.logOnUrl}?` +
          `login=${encodeURIComponent(login)}&` +
          `token=${logOnInfo.token}&` +
          `persistent=${persistent}`,
  });
}



// WEBPACK FOOTER //
// ./src/authenticator.ts